export const getMergedProductGiftCardData = (_, pageBuilderProductProps) => {
    const { variant = {} } = pageBuilderProductProps

    return {
        image: variant && variant.default_image
    }
}
